export const quoteStatuses = [
  'Draft',
  'Validate',
  'Pending Approval',
  'Approved - Export',
  'Sent to Customer',
  'Closed Won/Lost',
]

export const wonStatuses = ['Closed Won', 'Won - Draft Order', 'Won - Order Processing']

export const lostStatuses = ['Closed Lost']

export function statusesFor(status: string): string[] {
  const gate = wonStatuses.includes(status)
    ? 'Closed Won'
    : lostStatuses.includes(status)
    ? 'Closed Lost'
    : 'Closed Won/Lost'
  return [...quoteStatuses.slice(0, -1), gate, ...wonStatuses.slice(1)]
}

export const salesforceStages = [
  '1. Prospect',
  '2. Qualify',
  '3. Evaluate',
  '4. Proposal',
  '4b. Commitment',
  '5. Closed Won',
  '6. Closed Lost',
  '7. Duplicate',
  '8. No Bid',
]

export const salesforceForecastCategories = ['Pipeline', 'Best Case', 'Commit', 'Omitted', 'Closed']

export const coreCompetencies = ['Data Center', 'Networking', 'Security', 'Services', 'Workforce Enablement']

export const setAsides = [
  'Full & Open',
  'SB (Small Business)',
  'HUBZone (Historically Underutilized Business Zone)',
  'SDVOSB (Service-Disabled Veteran-Owned Small Business)',
  'WOSB (Woman-Owned Small Business)',
  '8(a) Business Development Program',
  'SDB (Small Disadvantaged Business)',
]

export const productTypes = [
  'Hardware',
  'Maintenance',
  'Mix',
  'Professional Service',
  'Software',
  'Service',
  'Warranty',
  'Other',
]

export const dpasRatingOptions: string[] = [
  'NONE',
  'DX-A1',
  'DX-A2',
  'DX-A3',
  'DX-A4',
  'DX-A5',
  'DX-A6',
  'DX-A7',
  'DX-B1',
  'DX-B8',
  'DX-B9',
  'DX-C1',
  'DX-C2',
  'DX-C3',
  'DX-C9',
  'DX-D1',
  'DX-D2',
  'DX-D3',
  'DX-G1',
  'DX-G2',
  'DX-G3',
  'DX-G4',
  'DX-J1',
  'DX-E1',
  'DX-E2',
  'DX-E3',
  'DX-F1',
  'DX-F2',
  'DX-F3',
  'DX-H1',
  'DX-H5',
  'DX-H6',
  'DX-H7',
  'DX-H8',
  'DX-K1',
  'DX-N1',
  'DX-N2',
  'DX-N3',
  'DX-N4',
  'DX-N5',
  'DX-N6',
  'DX-N7',
  'DX-N8',
  'DO-A1',
  'DO-A2',
  'DO-A3',
  'DO-A4',
  'DO-A5',
  'DO-A6',
  'DO-A7',
  'DO-B1',
  'DO-B8',
  'DO-B9',
  'DO-C1',
  'DO-C2',
  'DO-C3',
  'DO-C9',
  'DO-D1',
  'DO-D2',
  'DO-D3',
  'DO-G1',
  'DO-G2',
  'DO-G3',
  'DO-G4',
  'DO-J1',
  'DO-E1',
  'DO-E2',
  'DO-E3',
  'DO-F1',
  'DO-F2',
  'DO-F3',
  'DO-H1',
  'DO-H5',
  'DO-H6',
  'DO-H7',
  'DO-H8',
  'DO-K1',
  'DO-N1',
  'DO-N2',
  'DO-N3',
  'DO-N4',
  'DO-N5',
  'DO-N6',
  'DO-N7',
  'DO-N8',
]

export const securityRequirementOptions: string[] = ['DD254', 'Other', 'None']
